import { render, staticRenderFns } from "./DisasterClassSelector.vue?vue&type=template&id=1faffc49&scoped=true&"
import script from "./DisasterClassSelector.vue?vue&type=script&lang=js&"
export * from "./DisasterClassSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faffc49",
  null
  
)

export default component.exports